export interface IGetCbxEmployee {
  take: number;
  skip: number;
  search?: string;
}

export interface IGetRewardInfo {
  page: number;
  page_size: number;
  plantId?: string;
  jobTitleCode?: string;
  user?: string;
  status?: string;
  groupRoleManagementId?: string;
  groupId?: string;
  type?: any;
  headerRow?: any;
}

export interface ICreateNewUserReward {
  id: string;
  name: string;
  groupRoleManagementId: string;
  jobTitleCode: string;
  plantId: string;
  signDate: string;
  useYn: boolean;
  note: string;
}

export interface IUpdateUserRewardById extends ICreateNewUserReward {
  retireDate: string;
}

export const RewardInfoVariables = {
  getRewardInfo: (params: IGetRewardInfo) => {
    const {
      page,
      page_size,
      groupId,
      groupRoleManagementId,
      jobTitleCode,
      plantId,
      status,
      user,
    } = params;
    return {
      skip: (page - 1) * page_size,
      take: page_size,
      input: {
        ...(groupId && { groupId }),
        ...(groupRoleManagementId && { groupRoleManagementId }),
        ...(jobTitleCode && { jobTitleCode }),
        ...(plantId && { plantId }),
        ...(status && { status: status === 'R100_01' }),
        ...(user && { user }),
      },
    };
  },
  saveRewardInfo: (params: any) => {
    return {};
  },
  getCbxRewardCode: (params: any) => {
    return {};
  },
  getCbxUnit: (params: any) => {
    return {};
  },
  getCbxPosition: (params: any) => {
    return {};
  },
  getCbxEmployee: ({ skip, take, search }: IGetCbxEmployee) => {
    return {
      skip,
      take,
      input: {
        OR: search
          ? [
              {
                id: {
                  contains: search,
                },
              },
              {
                name: {
                  contains: search,
                },
              },
            ]
          : [],
      },
    };
  },
  getCbxObject: (params: any) => {
    return {};
  },
  getCbxGroup: (params: any) => {
    return {};
  },
  getCbxStatus: (params: any) => {
    return {};
  },
  createNewUserReward: (input: ICreateNewUserReward) => {
    return {
      input,
    };
  },
  updateUserRewardById: (input: IUpdateUserRewardById) => {
    return {
      input,
    };
  },
};
